import LoginModule from './login';
import TermsOfServiceController from './termsOfService';
import SignupModule from './signup';
import ResetPasswordModule from './resetPassword';
import CreateAccountModule from './createAccount';
import ForgotPasswordModule from './forgotPassword';
import VerifyEmailModule from './verifyEmail';


export default angular.module('app.guest.module',
	[
		LoginModule,
		TermsOfServiceController,
		SignupModule,
		ResetPasswordModule,
		CreateAccountModule,
		ForgotPasswordModule,
		VerifyEmailModule
	])
	.name;



/** WEBPACK FOOTER **
 ** ./src/guest/index.js
 **/